export default __webpack_public_path__ + "static/media/IconWebsite.75812396.svg";